import './scss/styles.scss';
import { EventEmitter } from './components/base/event';
import { ProductModel } from './components/models/ProductModal';
import { CartModel } from './components/models/CartModel';
import { ProductCard } from './components/views/ProductCard';
import { Modal } from './components/views/Modal';
import { CartViews } from './components/views/CartViews';
import { FormPayment } from './components/views/FormPayment';
import { ContactForm } from './components/views/ContactForm';
import { SuccessModal } from './components/views/SuccessModal';
import { PageView } from './components/views/PageView';
const eventEmitter = new EventEmitter();
const productModel = new ProductModel();
const cartModel = new CartModel();
const modal = new Modal();
const page = new PageView(eventEmitter);
const cartView = new CartViews(eventEmitter, (product) => {
    cartModel.removeFromCart(product.id);
});
const productCard = new ProductCard(document.querySelector('#card-catalog'), (id) => {
    const product = productModel.getProductById(id);
    if (product) {
        modal.open(productCard.renderPreview(product));
        const buyButton = modal.getContent().querySelector('.card__button');
        buyButton === null || buyButton === void 0 ? void 0 : buyButton.addEventListener('click', () => {
            cartModel.addToCart(product);
            modal.close();
        });
    }
});
// При загрузке списка товаров
productModel.on('products-updated', (products) => {
    const cards = products.map(product => productCard.render(product));
    page.renderGallery(cards);
});
// Общая функция создания элемента корзины
const createBasketItem = (item, index, onRemove) => {
    const itemElement = document.createElement('div');
    itemElement.className = 'basket__item';
    const indexSpan = document.createElement('span');
    indexSpan.className = 'basket__item-index';
    indexSpan.textContent = (index + 1).toString();
    itemElement.appendChild(indexSpan);
    const title = document.createElement('h3');
    title.className = 'card__title';
    title.textContent = item.product.title;
    itemElement.appendChild(title);
    const price = document.createElement('p');
    price.className = 'card__price';
    price.textContent = item.product.price ? `${item.product.price} синапсов` : 'Бесценно';
    itemElement.appendChild(price);
    const deleteButton = document.createElement('button');
    deleteButton.className = 'basket__item-delete';
    deleteButton.textContent = 'Удалить';
    deleteButton.addEventListener('click', (e) => {
        e.preventDefault();
        onRemove(item.product.id);
    });
    itemElement.appendChild(deleteButton);
    return itemElement;
};
// При изменении корзины
cartModel.on('cart-change', (state) => {
    page.updateBasketCounter(state.items.length);
    // Генерация карточек корзины
    const basketCards = state.items.map((item, index) => createBasketItem(item, index, (id) => cartModel.removeFromCart(id)));
    modal.open(cartView.render(state));
});
// Открытие корзины
eventEmitter.on('cart:open', () => {
    const state = cartModel.getCartState();
    const basketCards = state.items.map((item, index) => createBasketItem(item, index, (id) => cartModel.removeFromCart(id)));
    modal.open(cartView.render(state));
});
// Обработка оформления заказа (мок)
eventEmitter.on('order:submit', () => {
    const paymentForm = new FormPayment((paymentData) => {
        const contactForm = new ContactForm((contactData) => {
            // Собираем данные (без отправки на сервер)
            const orderData = Object.assign(Object.assign(Object.assign({}, paymentData), contactData), { items: cartModel.getCartState().items.map(item => item.product.id), total: cartModel.getCartState().totalPrice });
            // Просто показываем успех
            cartModel.clearCart();
            page.updateBasketCounter(0);
            const successModal = new SuccessModal(() => {
                modal.close();
            });
            modal.open(successModal.render(orderData.total));
        });
        modal.open(contactForm.render());
    });
    modal.open(paymentForm.render());
});
productModel.fetchProducts();
